import { Injectable } from '@angular/core';
import { AuthTokenService } from '@kempoweroyj/ngx-auth-token-service';
export interface AppConfig {
    envName: 'dev' | 'prod' | 'test';

    /** API base url (without protocol and the /api suffix), e.g. kempower.io */
    apiBaseUrl: string;

    loginUrl: string;

    /** Authentication related settings */
    auth: {
        /** Auth0 domain e.g. kempower-dev.eu.auth0.com */
        domain: string;
        clientId: string;
        audience: string;
    };

    mapTilerApiKey?: string;

    /** Sentry DSN */
    sentryDsn: string;

    /** Sentry replay sample rate for visualizing UI events in Sentry (0.0 - 1.0) */
    sentryReplaySampleRate: number;
}

let AppConfig: AppConfig;

/** Called from main.ts which loads config from /config.json */
export function setCsmsAppConfig(appConfig: AppConfig) {
    AppConfig = appConfig;
}

@Injectable()
export class ConfigService {
    constructor(private authToken: AuthTokenService) {
        this.authToken.restApiUrl = this.restApiUrl;
    }

    get config(): AppConfig {
        return AppConfig;
    }

    get restApiUrl(): string {
        return `https://${this.config.apiBaseUrl}/api`;
    }

    get notificationsWebSocketUrl(): string {
        return `wss://${this.config.apiBaseUrl}/notifications`;
    }

    public readonly notificationsSendMessageAuditTimeMs: number = 2_000;
}
